import React from 'react';


class Comp extends React.Component {

	render() {
		let data = this.props.data;

		let color;
		if (data.sex === 'men') {
			color = '#4376AB';
		}
		else {
			color = '#CD4695';
		}
		return (
			<span
				style={{
					color: color,
					fontSize: data.size,
					fontWeight: 900,
					textShadowColor: 'rgba(255, 255, 255, 1)',
					textShadowOffset: {width: 1, height: 1},
					textShadowRadius: 1,
					width:'100%',
					whiteSpace:'nowrap',
					overflow:'hidden',
					textOverflow:'ellipsis',
				}}
			>
				{ data.name }
			</span>
		)
	}
}

export default Comp;
